import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { CheckCircle2, Undo2 } from "lucide-react";
import { money, fmtDate, PayStatus } from "../team/shared";

export function PayoutPanel({ memberId, onChange }) {
  const [d, setD] = useState(null);
  const [notes, setNotes] = useState({});
  const load = () => client.get(`/partners/${memberId}/earnings`).then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, [memberId]); // eslint-disable-line react-hooks/exhaustive-deps
  const pay = async (period) => {
    try { await client.post(`/partners/${memberId}/payouts`, { period, note: notes[period] || "" }); toast.success(`${period} marked paid`); load(); onChange(); } catch (e) { toast.error(apiErr(e)); }
  };
  const undo = async (po) => {
    if (!window.confirm(`Undo payout of ${money(po.amount)} for ${po.period}?`)) return;
    try { await client.delete(`/partners/payouts/${po.id}`); toast.success("Payout undone"); load(); onChange(); } catch (e) { toast.error(apiErr(e)); }
  };
  if (!d) return null;
  return (
    <div className="mb-6" data-testid="payout-panel">
      <div className="flex items-center gap-3 mb-2">
        <span className="text-[11px] uppercase tracking-widest text-slate-500">Payouts</span>
        <span className="ml-auto text-xs text-slate-400">Paid <span className="font-mono text-bull" data-testid="payout-paid-total">{money(d.paid_total)}</span> · Pending <span className="font-mono text-white" data-testid="payout-pending-total">{money(d.pending_total)}</span></span>
      </div>
      {d.by_period.length === 0 && <div className="text-xs text-slate-500 py-2">No earnings yet.</div>}
      {d.by_period.map((p) => (
        <div key={p.period} data-testid={`payout-period-${p.period}`} className="surface p-3 mb-2">
          <div className="flex items-center gap-2">
            <span className="text-white text-sm">{p.period}</span>
            <PayStatus status={p.status} testid={`payout-status-${p.period}`} />
            <span className="ml-auto font-mono text-gold text-sm">{money(p.amount)}</span>
          </div>
          {p.payouts.map((po) => (
            <div key={po.id} className="flex items-center gap-2 text-[11px] text-slate-400 mt-1.5">
              <CheckCircle2 size={12} className="text-bull" />{money(po.amount)} · {fmtDate(po.paid_at)}{po.note ? ` · ${po.note}` : ""}
              <button data-testid={`undo-payout-${po.id}`} onClick={() => undo(po)} className="ml-auto flex items-center gap-1 text-slate-500 hover:text-bear"><Undo2 size={12} />Undo</button>
            </div>
          ))}
          {p.pending > 0 && (
            <div className="flex gap-2 mt-2">
              <input data-testid={`payout-note-${p.period}`} value={notes[p.period] || ""} onChange={(e) => setNotes({ ...notes, [p.period]: e.target.value })} placeholder="UPI / Bank ref (optional)" className="flex-1 min-w-0 bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-2 py-1.5 text-xs text-white focus:border-gold focus:outline-none" />
              <button data-testid={`mark-paid-${p.period}`} onClick={() => pay(p.period)} className="btn-gold px-3 text-xs whitespace-nowrap">Mark Paid {money(p.pending)}</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
